import { applyCasinoQueries, QueryBuilder } from "./Helpers";
export const CasinoConnection = {
    getCategories(params) {
        return applyCasinoQueries(QueryBuilder.getCategories(params));
    },
    getFreespins(params) {
        return applyCasinoQueries(QueryBuilder.getFreespins(params));
    },
    getGames(params) {
        return applyCasinoQueries(QueryBuilder.getGames(params));
    },
    getLaunchParams(params) {
        return applyCasinoQueries(QueryBuilder.getLaunchParams(params));
    }
};
//# sourceMappingURL=CasinoConnection.js.map